import { useCallback } from "react";

const FILTERED_ARTICLE = ["imageUpload"];

const SOCIAL_MEDIA = [
  "twitter",
  "youtube",
  "facebook",
  "instagram",
  "linkedin",
  "tiktok",
  "imageBlock",
  "videoBlock",
  "insideLink",
];
export function appendRequiredBlocksMarkerClient(body) {
  if (!body) return body;
  return {
    ...body,
    content: body.content
      ?.filter((c) => !FILTERED_ARTICLE.includes(c.type))
      ?.map((block, index) => {
        if (SOCIAL_MEDIA.includes(block.type)) {
          return {
            ...block,
            attrs: {
              ...block.attrs,
              "data-id": index,
              key: Math.random(),
              side: block.attrs?.class?.includes("side"),
              inline: block.attrs?.class?.includes("inline"),
            },
          };
        }

        return block;
      }),
  };
}
